// İletişim Raporu — standart Hasura permission'ları üzerinden çalışır.
// Bu raporu kullanabilmek için kullanıcının (a) `can_view_communication_report=true`
// olması (FE button gating) ve (b) firms/sectors/firm_carts üzerinde okuma
// yetkisi olması gerekir. Yetkilendirme admin tarafından "Kullanıcılar"
// formundan yapılır.
//
// Active jobs filter sadece JS tarafında uygulanır — Hasura query company +
// sektör koşullarıyla tüm firmaları getirir, modal preview öncesinde
// `with_active` / `without_active` / `all` durumuna göre filtrelenir.

export const GET_FIRMS_COMMUNICATION_REPORT = `
  query FirmCommunicationReport($companyId: Int!, $sectorIds: [Int!]!) {
    firms(
      where: {
        company_id: { _eq: $companyId }
        firm_sectors: { sector_id: { _in: $sectorIds } }
      }
      order_by: { firm_name: asc }
    ) {
      id
      firm_name
      firm_short_name
      is_established
      firm_carts {
        firm_cart_firstname
        firm_cart_lastname
        firm_cart_title
        firm_cart_mail
        firm_cart_phone
        firm_cart_second_phone
        firm_cart_status
      }
      firm_sectors {
        sector {
          id
          sector_name
        }
      }
      jobs(
        where: {
          job_status: {
            _nin: [TAMAMLANDI, KAPATILDI, DANISMANLIK_SONLANDIRILDI]
          }
        }
        limit: 1
      ) {
        id
      }
    }
  }
`;
